var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.$t('global.install-certificate'),"help":{
    message: _vm.$t('global.install-certificate-desc'),
  }}},[(_vm.status.isLoading)?_c('LoadingState'):(_vm.status.isErrored)?_c('ErrorState'):(_vm.status.isLoaded)?_c('CertificateInstallForm',{attrs:{"site":_vm.site,"certificates":_vm.certificates}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }